import axios from "axios";
import axiosRetry from "axios-retry";
import toastr from "toastr";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import plantillaCuestionarioServices from "./plantillaCuestionario.services";

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

// const sort_lists = (key, list, inverse) =>
//   inverse
//     ? [...list].sort((b, a) =>
//         b[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : 1
//       )
//     : [...list].sort((a, b) =>
//         a[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : -1
//       );

export const getPlantillaCuestionarios = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLANTILLA_CUESTIONARIO,
      payload: true,
    });
    const resp = await plantillaCuestionarioServices.getPlantillaCuestionarios(
      filters
    );
    dispatch({
      type: actions.GET_PLANTILLA_CUESTIONARIO,
      payload: resp.data,
    });
    dispatch({
      type: actions.PLANTILLA_CUESTIONARIO_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.PLANTILLA_CUESTIONARIO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLANTILLA_CUESTIONARIO,
      payload: false,
    });
  }
};

export const getPlantillaCuestionariosById =
  (
    id,
    setPlantillasT,
    setPreguntasT,
    setNombrePlantilla,
    setDescripcionPlantilla
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.getPlantillaCuestionariosById(id);
      let _data = resp.data;
      let _preguntas = resp.data.list_preguntas
        ? // ? sort_lists("posicion", resp.data.list_preguntas)
          resp.data.list_preguntas
        : null;
      _data.list_preguntas = _preguntas;
      if (
        setPreguntasT ||
        setPlantillasT ||
        setNombrePlantilla ||
        setDescripcionPlantilla
      ) {
        if (setPlantillasT) {
          setPlantillasT(_data);
        }
        if (setPreguntasT) {
          setPreguntasT(_preguntas);
        }
        if (setNombrePlantilla) {
          setNombrePlantilla(_data.nombre);
        }
        if (setDescripcionPlantilla) {
          setDescripcionPlantilla(_data.descripcion);
        }
      } else {
        dispatch({
          type: actions.GET_PLANTILLA_CUESTIONARIO,
          payload: _data,
        });
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

export const savePlantillaCuestionariosImport =
  (req, setShowModalPlantilla) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.savePlantillaCuestionariosImport(
          req
        );
      let { data, count } = getState().plantillaCuestionario.surveyTemplate;
      let { data: dataImport, count: countImport } =
        getState().plantillaCuestionario.surveyTemplateImport;
      let _resp = resp.data[0];
      data = [...data, _resp];
      dataImport = [...data, _resp];
      dispatch({
        type: actions.GET_SAVE_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: {
          surveyTemplateImport: { data: dataImport, count: countImport + 1 },
          surveyTemplate: { data: data, count: count + 1 },
        },
      });
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_IMPORT_FAIL,
        payload: null,
      });
      setShowModalPlantilla(false);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_IMPORT_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: false,
      });
    }
  };

// Para clonar cuestionario
export const getPlantillaCuestionariosImport =
  (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.getPlantillaCuestionarios(filters);
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: resp.data,
      });
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_IMPORT_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_IMPORT_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: false,
      });
    }
  };
//

export const savePlantillaCuestionarios =
  (req, history) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.savePlantillaCuestionarios(req);
      const { data, count } = getState().plantillaCuestionario.surveyTemplate;
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO,
        payload: {
          data: [...data, resp.data],
          count: count + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      history.push(
        `/cuestionario/${resp.data.id}/${resp.data.nombre.replaceAll("/", "-")}`
      );
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

export const clonePlantillaCuestionario =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.clonePlantillaCuestionario(req);
      let { data, count } = getState().plantillaCuestionario.surveyTemplate;
      data = [...data, resp.data];
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO,
        payload: {
          data: data,
          count: count + 1,
        },
      });
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: {
          data: data,
          count: count + 1,
        },
      });
      dispatch({
        type: actions.FORM_IMPORT_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_IMPORT_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: false,
      });
    }
  };

export const editPlantillaCuestionarios =
  (req, id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.editPlantillaCuestionarios(id, req);
      const { data, count } = getState().plantillaCuestionario.surveyTemplate;
      data[index] = resp.data;
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO,
        payload: {
          data: data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

export const deletePlantillaCuestionarios =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      await plantillaCuestionarioServices.deletePlantillaCuestionarios(id);
      const { data, count } = getState().plantillaCuestionario.surveyTemplate;
      data.splice(index, 1);
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO,
        payload: {
          data: data,
          count: count - 1,
        },
      });
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

export const plantillaCuestionarioCopy =
  (req, history) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.savePlantillaCuestionarios(req);
      const { data, count } = getState().plantillaCuestionario.surveyTemplate;
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO,
        payload: {
          data: [...data, resp.data],
          count: count + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      history.push(
        `/cuestionario/${resp.data.id}/${resp.data.nombre.replaceAll("/", "-")}`
      );
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

// Para obtener preguntas
export const getPreguntasPlantillaCuestionarios =
  (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO_PREGUNTAS,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.getPreguntasPlantillaCuestionarios(
          filters
        );
      dispatch({
        type: actions.GET_PLANTILLA_CUESTIONARIO_PREGUNTAS,
        payload: resp.data,
      });
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTAS_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTAS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLANTILLA_CUESTIONARIO_PREGUNTAS,
        payload: false,
      });
    }
  };

// Para crear preguntas
export const savePlantillaCuestionariosPregunta =
  (req, data, setData) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.savePlantillaCuestionariosPregunta(
          req
        );
      if (data) {
        setData([...data, resp.data[0]]);
      } else {
        setData([resp.data[0]]);
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: false,
      });
    }
  };

// Para eliminar preguntas
export const deletePlantillaCuestionariosPregunta =
  (id, index, data, setData) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: true,
      });
      await plantillaCuestionarioServices.deletePlantillaCuestionariosPregunta(
        id
      );
      let _data = data;
      _data.splice(index, 1);
      if (_data.length > 0) {
        setData(_data);
      } else {
        setData(null);
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: false,
      });
    }
  };

// Para agregar opciones
export const savePlantillaCuestionariosOpciones =
  (req, setLoader, opciones, setOpciones) => async () => {
    try {
      setLoader(true);

      const resp =
        await plantillaCuestionarioServices.savePlantillaCuestionariosOpciones(
          req
        );
      let _opciones = opciones;
      setOpciones([..._opciones, resp.data]);

      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      toastr.error(message);
    } finally {
      setLoader(false);
    }
  };

// Para eliminar opciones
export const deletePlantillaCuestionariosOpciones =
  (id, index, setLoader, data, setData) => async (dispatch) => {
    try {
      setLoader(true);
      await plantillaCuestionarioServices.deletePlantillaCuestionariosOpciones(
        id
      );
      let _data = data;
      _data.splice(index, 1);
      if (_data.length > 0) {
        setData(_data);
      } else {
        setData(null);
      }
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message);
    } finally {
      setLoader(false);
    }
  };

// Para editar medición
export const editPlantillaCuestionariosPreguntaMedicion =
  (data, id, setSaveLoader) => async () => {
    try {
      setSaveLoader(true);
      await plantillaCuestionarioServices.editPlantillaCuestionariosOpciones(
        id,
        data
      );
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message);
    } finally {
      setSaveLoader(false);
    }
  };

// Para editar categoria
export const editPlantillaCuestionariosCategorias =
  (data, id, setShowModalCategoria, plantilla, setPlantilla) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.editPlantillaCuestionarios(
          id,
          data
        );
      let _plantilla = plantilla;
      _plantilla.objeto = resp.data.objeto;
      _plantilla.list_Clima_Objeto[0] = resp.data.objeto_list;
      setPlantilla(_plantilla);
      toastr.success(messages.successMessage);
      setShowModalCategoria(false);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message);
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };

// Para importar opciones
export const guardarImportarPreguntasPlantillaCuestionario =
  (data, setShowModal, setShowModalPreguntas, preguntas, setPreguntas) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.guardarImportarPreguntasPlantillaCuestionario(
          data
        );
      let _preguntas = preguntas;
      _preguntas = resp.data[0].list_preguntas;
      setPreguntas(_preguntas);
      setShowModal(false);
      setShowModalPreguntas(false);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      toastr.error(message);
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT,
        payload: false,
      });
    }
  };

// Para crear preguntas
export const saveCambiarPlantillaCuestionariosTipoPregunta =
  (req, data, setData, preguntas, setPreguntas, index) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: true,
      });
      const resp =
        await plantillaCuestionarioServices.saveCambiarPlantillaCuestionariosTipoPregunta(
          req
        );
      const _resp = resp.data[0];
      // setData(sort_lists("posicion", _resp.list_Plantilla_Opciones));
      setData(_resp.list_Plantilla_Opciones);
      let _preguntas = preguntas;
      _preguntas[index] = _resp;
      setPreguntas(_preguntas);
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA,
        payload: false,
      });
    }
  };

// Para guardar cuestionario completo
export const saveMasiveCuestion =
  (req, setPlantillasT, setPreguntasT) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: true,
      });
      const resp = await plantillaCuestionarioServices.saveMasiveCuestion(req);
      let _data = resp.data[0];
      let _preguntas =
        resp.data[0] && resp.data[0].list_preguntas
          ? // ? sort_lists("posicion", resp.data[0].list_preguntas)
            resp.data[0].list_preguntas
          : null;
      _data.list_preguntas = _preguntas;
      if (setPreguntasT && setPlantillasT) {
        setPlantillasT(_data);
        setPreguntasT(_preguntas);
      } else {
        dispatch({
          type: actions.GET_PLANTILLA_CUESTIONARIO,
          payload: _data,
        });
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_FAIL,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLANTILLA_CUESTIONARIO_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_PLANTILLA_CUESTIONARIO,
        payload: false,
      });
    }
  };
